<template>
<header class="form-header">
  <img class="games-logo" alt="Samaggi Games" src="./assets/logo.png">
  <h2 class="text-center">Samaggi Games 2020 in Bangkok</h2>
  <h2 class="text-center">University registration</h2>
  <hr>
  <p v-if="formState === formStates.ready || formState === formStates.submittedFailed">This form is to be submitted once per university by a representative of the university&rsquo;s Thai society. The registration will be closed on <span class="font-bold">the 18<sup>th</sup> October 2020, 12pm local time (GMT+7)</span>.</p>
</header>
<keep-alive>
<div v-if="formState === formStates.loading">
  <p class="text-center">
    <img src="/loading.gif" alt="Now loading..." />
  </p>
  <p class="text-center" v-if="loadingError">
    There was an error, please try again later.
  </p>
</div>
<div v-else-if="formState === formStates.outsideSubmissionPeriod">
  <h3>The registration for Samaggi Games 2020 in Bangkok has been closed.</h3>
  <p>Thank you for your interest.</p>
</div>
<div v-else-if="formState === formStates.submittedSuccess">
  <h3>Thank you for your submission</h3>
  <p>The registration ID of this submission is #{{ submissionResult.registration_id }}</p>
  <p v-if="submissionResult.email_success">
    An email record of your submission has been sent to {{ contact.primary.email }},
    please check your spam box in case your email provider considers our email a junk mail.
  </p>
  <p v-else>
    There was an error sending email to {{ contact.primary.email }},
    Please contact us directly via <a href="mailto:game@samaggisamagom.com">game@samaggisamagom.com</a>
  </p>
  <p>
    Your submission is being moderated. Once the process has been completed, a confirmation email will be sent to you with an actual invoice and the payment details.
  </p>
</div>
<form
  v-else-if="formState === formStates.ready || formState === formStates.submittedFailed"
  id="appForm"
  v-on:submit.prevent="onSubmit"
>
  <div v-if="formState === formStates.submittedFailed">
    <h3>There was an error.</h3>
    <p>{{ errorMessage }}</p>
  </div>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-building" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694L1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"/>
          <path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"/>
        </svg>
        University details
      </h3>
    </div>
<!--
    <div class="input-block">
      <div><label for=""></label></div>
      <div><input id="" type="text" v-model="" /></div>
    </div>
-->
    <div class="input-block">
      <div><label for="fullUniversityName">Full university name</label></div>
      <div><input id="fullUniversityName" type="text" v-model="fullUniversityName" required /></div>
    </div>
  </section>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-person-lines-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>
        </svg>
        Contact details
      </h3>
    </div>
    <section>
      <h4>Primary contact person</h4>
      <div class="input-block">
        <div><label for="primaryContactFullName">Full name</label></div>
        <div><input id="primaryContactFullName" type="text" v-model="contact.primary.fullName" required autocomplete="name" /></div>
      </div>
      <div class="input-block">
        <div><label for="primaryContactLineId">Line ID</label></div>
        <div><input id="primaryContactLineId" type="text" v-model="contact.primary.lineId" required autocomplete="username" /></div>
      </div>
      <div class="input-block">
        <div><label for="primaryContactPhone">Phone</label></div>
        <div><input id="primaryContactPhone" type="tel" v-model="contact.primary.phone" required autocomplete="tel" /></div>
      </div>
      <div class="input-block">
        <div><label for="primaryContactEmail">University Email</label></div>
        <div><input id="primaryContactEmail" type="email" v-model="contact.primary.email" required autocomplete="email" /></div>
        <p>(The confirmation email of your registration will be sent to this address)</p>
      </div>
      <div class="input-block">
        <div><label>
          <input type="checkbox" v-model="contact.primary.isPresident"
          />This person serves as the president (or any equivalent position) of this Thai society.
        </label></div>
      </div>
    </section>
    <section>
      <h4>Secondary contact person</h4>
      <div class="input-block">
        <div><label for="secondaryContactFullName">Full name</label></div>
        <div><input id="secondaryContactFullName" type="text" v-model="contact.secondary.fullName" required /></div>
      </div>
      <div class="input-block">
        <div><label for="secondaryContactLineId">Line ID</label></div>
        <div><input id="secondaryContactLineId" type="text" v-model="contact.secondary.lineId" required /></div>
      </div>
      <div class="input-block">
        <div><label for="secondaryContactPhone">Phone</label></div>
        <div><input id="secondaryContactPhone" type="tel" v-model="contact.secondary.phone" required /></div>
      </div>
      <div class="input-block">
        <div><label for="secondaryContactEmail">University Email</label></div>
        <div><input id="secondaryContactEmail" type="email" v-model="contact.secondary.email" required /></div>
      </div>
    </section>
  </section>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-people" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1h7.956a.274.274 0 0 0 .014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 0 0 .022.004zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
        </svg>
        Attendees
      </h3>
    </div>
    <p>Attendee tickets are required for all spectators.</p>
    <div class="input-block">
      <div><label for="attendeesSameUniversity"><h4>Current students from {{ niceUniversityName }}</h4></label></div>
      <div>
        <textarea
          id="attendeesSameUniversity"
          v-model="rawAttendees.fromSameUniversity"
          placeholder="Full names in separated lines, e.g.,&#10;Boris Johnson&#10;Theresa May&#10;..."
         />
      </div>
      <p>Total: {{ attendeesFromSameUniversity.length }} person(s)</p>
    </div>
    <hr>
    <div class="input-block">
      <div><label for="attendeesNonUK"><h4>Non-UK students and/or alumni</h4></label></div>
      <div>
        <textarea
          id="attendeesNonUK"
          v-model="rawAttendees.nonUK"
          placeholder="Full names in separated lines, e.g.,&#10;Boris Johnson&#10;Theresa May&#10;..."
        />
      </div>
      <p>Total: {{ attendeesNonUK.length }} person(s)</p>
    </div>
    <hr>
    <h4>Student attendees from other UK universities</h4>
    <section v-for="(entry, index) in rawAttendeesFromOtherUniversities" :key="entry.key">
      <h5>Students from university #{{ index + 1 }}: {{ entry.universityName }}</h5>
      <div class="input-block">
        <div><label v-bind:for="'attendees_fullUniversityName_' + entry.key">Full university name</label></div>
        <div><input v-bind:id="'attendees_fullUniversityName_' + entry.key" type="text" v-model="entry.universityName" required /></div>
      </div>
      <div class="input-block">
        <div><label v-bind:for="'attendees_list_' + entry.key">Current students from {{ entry.universityName ? entry.universityName : "this university" }}</label></div>
        <div>
          <textarea
            v-bind:id="'attendees_list_' + entry.key"
            v-model="entry.list"
            placeholder="Full names in separated lines, e.g.,&#10;Boris Johnson&#10;Theresa May&#10;..."
            required
            v-on:input="validateAttendeesList"
          />
        </div>
        <p>Total: {{ attendeesFromOtherUniversities[index].students.length }} student(s)</p>
      </div>
      <div class="button-block">
        <button v-on:click.prevent="removeAttendeeUniversity(index)" class="btn btn-light">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-dash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
          </svg>
          Remove all attendees from {{ entry.universityName ? entry.universityName : "this university" }}
        </button>
      </div>
    </section>
    <div class="button-block">
      <button v-on:click.prevent="addAtttendeeUniversity" class="btn btn-light">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Add more university
      </button>
    </div>
    <hr>
    <p class="bigger font-bold">Total number of attendee(s): {{ grandTotalAttendees }} attendee(s)</p>
  </section>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trophy" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z"/>
        </svg>
        Athletes
      </h3>
    </div>
    <p>
      Please note that if the number of the registered teams exceeds the maximum number of teams allowed
      to play on the day, we will host a pre-qualifying round in which all teams competing on the day will
      be selected randomly for fairness&mdash;not all teams will be participating&mdash;and notified at least 1 week
      prior to the pre-qualifying day. Samaggi Samagom would like to apologise for the inconvenience.
    </p>
    <hr>
    <h4>Male athletes</h4>
    <p>This section is reserved for biological-male UK students or alumni only with 2 sport options including basketball and football.</p>
    <h5 style="padding-top:1rem">Athletes from {{ niceUniversityName }}</h5>
    <p>There is no limit on the number of athletes from {{ niceUniversityName }}.</p>
    <section v-for="(athlete, index) in athletesFromSameUniversiy" :key="athlete.key">
      <p class="font-bold">Athlete#{{ index + 1 }}: {{ athlete.fullName }}</p>
      <div class="input-block">
        <div><label v-bind:for="'athlete_same_' + athlete.key">Full athlete's name</label></div>
        <div><input v-bind:id="'athlete_same_' + athlete.key" type="text" v-model="athlete.fullName" required /></div>
      </div>
      <div class="input-block">
        <div><label>
          <input type="checkbox" v-model="athlete.isAlumni"
          />This person is an alumni (i.e., a former UK student from {{ niceUniversityName }})
        </label></div>
      </div>
      <div class="input-block">
        <div><label>
          Sports that
          {{ athlete.fullName.trim() ? athlete.fullName : 'this athlete' }}
          would like to compete in
        </label></div>
        <div>
          <label>
            <input
              type="checkbox"
              v-model="athlete.playBasketball"
              v-bind:ref="'playBasketballSameUniversityCheckbox_' + athlete.key"
              v-on:change="validateSportsFromSameUniversity(athlete.key, index)"
            />Basketball
          </label>
          <label>
            <input
              type="checkbox"
              v-model="athlete.playFootball"
              v-bind:ref="'playFootballSameUniversityCheckbox_' + athlete.key"
              v-on:change="validateSportsFromSameUniversity(athlete.key, index)"
            />Football (soccer)
          </label>
        </div>
      </div>
      <div class="button-block">
        <button v-on:click.prevent="removeAthleteFromSameUniversity(index)" class="btn btn-light">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-dash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
          </svg>
          Remove {{ athlete.fullName.trim() ? 'athlete ' + athlete.fullName : 'this athlete' }}
        </button>
      </div>
    </section>
    <div class="button-block">
      <button v-on:click.prevent="addAthleteFromSameUniversity" class="btn btn-light">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Add an athlete from {{ niceUniversityName }}
      </button>
    </div>
    <p>Total number of athlete(s) from {{ niceUniversityName }}: {{ athletesFromSameUniversiy.length }} athlete(s)</p>
    <hr class="dashed">
    <h5>External athletes</h5>
    <p>
      Each Thai society is allowed to take up to <span class="font-bold">4 athletes for football</span> and <span class="font-bold">3 athletes for basketball</span> from other UK universities under the condition that the external athletes' universities do not submit a team in this competition.
    </p>
    <section v-for="(athlete, index) in athletesFromOtherUniversiy" :key="athlete.key">
      <p class="font-bold">Athlete#{{ index + 1 }}: {{ athlete.fullName }}</p>
      <div class="input-block">
        <div><label v-bind:for="'athlete_other_' + athlete.key">Full athlete's name</label></div>
        <div><input v-bind:id="'athlete_other_' + athlete.key" type="text" v-model="athlete.fullName" required /></div>
      </div>
      <div class="input-block">
        <div><label v-bind:for="'athlete_other_uni_' + athlete.key">
          Full university name
          {{ athlete.fullName.trim() ? 'of ' + athlete.fullName : '' }}
        </label></div>
        <div><input v-bind:id="'athlete_other_uni_' + athlete.key" type="text" v-model="athlete.universityName" required /></div>
      </div>
      <div class="input-block">
        <div><label>
          <input type="checkbox" v-model="athlete.isAlumni"
          />This person is an alumni (i.e., a former UK student of
          {{ athlete.universityName.trim() ? athlete.universityName : 'their university' }})
        </label></div>
      </div>
      <div class="input-block">
        <div><label>
          Sports that
          {{ athlete.fullName.trim() ? athlete.fullName : 'this athlete' }}
          would like to compete in
        </label></div>
        <div>
          <label>
            <input
              type="checkbox"
              v-model="athlete.playBasketball"
              v-bind:ref="'playBasketballOtherUniversityCheckbox_' + athlete.key"
              v-on:change="validateSportsFromOtherUniversity"
            />Basketball
          </label>
          <label>
            <input
              type="checkbox"
              v-model="athlete.playFootball"
              v-bind:ref="'playFootballOtherUniversityCheckbox_' + athlete.key"
              v-on:change="validateSportsFromOtherUniversity"
            />Football (soccer)
          </label>
        </div>
      </div>
      <div class="button-block">
        <button v-on:click.prevent="removeAthleteFromOtherUniversity(index)" class="btn btn-light">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-dash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
          </svg>
          Remove {{ athlete.fullName.trim() ? 'athlete ' + athlete.fullName : 'this athlete' }}
        </button>
      </div>
    </section>
    <div class="button-block">
      <button v-on:click.prevent="addAthleteFromOtherUniversity" v-bind:disabled="athletesFromOtherUniversiy.length >= 7" class="btn btn-light">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Add an external athlete
      </button>
    </div>
    <p>Total number of external athlete(s): {{ athletesFromOtherUniversiy.length }} athlete(s)</p>
    <hr>
    <h4>Female athletes</h4>
    <p>This section is reserved for biological-female UK students or alumni only.</p>
    <div class="input-block">
      <div>
        <label for="chairballAthletes">
          <h5 style="padding-top:0.5rem">Chairball athletes: </h5>
        </label>
      </div>
      <p>Each chairball team must consist of <b>a mininum of 7 players</b>. There is no limit on the number of external athletes or alumni for this sport.</p>
      <div>
        <textarea
          id="chairballAthletes"
          v-model="rawChairballAthletes"
          placeholder="Full names in separated lines, e.g.,&#10;Boris Johnson&#10;Theresa May&#10;..."
         />
      </div>
      <p>Total: {{ athletesChairball.length }} athlete(s)</p>
    </div>
    <p class="bigger font-bold">Total number of athlete(s): {{ grandTotalAthletes }} athlete(s)</p>
  </section>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-credit-card-2-back" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M14 3H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>
          <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zM1 9h14v2H1V9z"/>
        </svg>
        Tentative Invoice
      </h3>
    </div>
    <p>
      This invoice is preliminary&mdash;generated from the number of participants given above.
      The actual invoice will be sent to
      {{ contact.primary.email.trim() ? contact.primary.email : 'the primary contact email' }}
      directly once we have moderated your submission.
    </p>
    <h4>Items</h4>
    <p>
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-people" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1h7.956a.274.274 0 0 0 .014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 0 0 .022.004zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
      </svg>
      <span class="font-bold">Attendee ticket(s): {{ grandTotalAttendees }}</span><br />
      Price per attendee ticket: 150 THB<br />
      Amount: {{ attendeeAmount }} THB
    </p>
    <p>
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trophy" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z"/>
      </svg>
      <span class="font-bold"> Athlete ticket(s): {{ grandTotalAthletes }}</span><br />
      Price per athlete ticket: 400 THB<br />
      Amount: {{ athleteAmount }} THB
    </p>
    <p>Sub total: {{ subTotal }} THB</p>
    <hr>
    <h4>Discount</h4>
    <p>
      Get 1
      <span class="font-bold">FREE</span>
      attendee ticket when purchasing 10 athlete tickets.</p>
    <p>
      Eligible <span class="font-bold">FREE</span> attendee ticket(s): {{ eligibleFreeAttendeeTickets }}<br />
      Discount applied: {{ discountedAttendeeTickets }}<br /><br />
      Total discount: {{ discountTotal }} THB
    </p>
    <hr>
    <h4>Grand total</h4>
    <p class="bigger font-bold">{{ grandTotal }} THB</p>
    <p>
      Please note that all tickets are non-refundable.
    </p>
  </section>
  <section>
    <div class="box">
      <h3>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-file-text" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4z"/>
          <path fill-rule="evenodd" d="M4.5 10.5A.5.5 0 0 1 5 10h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"/>
        </svg>
        Privacy Policy
      </h3>
    </div>
    <p>This form is completely confidential. The information you provide will only be used for Samaggi Games 2020
      in Bangkok. All information will be treated in accordance with the Data Protection Act.
      By submitting this form, you agree that the data subjects have been informed about the data collection
      and provided with the <a href="https://www.samaggisamagom.com/privacy-policy/">privacy information</a>.</p>
  </section>
  <footer>
    <div class="button-block">
      <button class="btn btn-warning" type="submit">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
        </svg>
        Submit this registration
      </button>
    </div>
  </footer>
</form>
</keep-alive>
<footer>&copy; 2020 Samaggi Samagom. All rights reserved.</footer>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
const axios = require('axios')

const formStates = {
  outsideSubmissionPeriod: -1,
  loading: 0,
  ready: 1,
  submittedSuccess: 2,
  submittedFailed: 3
}
export default {
  name: 'App',
  beforeCreate: function () {
    this.gamesApi = axios.create({
      baseURL: process.env.VUE_APP_API_BASE
    })
    this.statusPromise = this.gamesApi.get('/status')
  },
  created: function () {
    var thisVue = this
    this.formStates = formStates
    this.statusPromise
      .then(function (response) {
        if (response.data.registration_opened) {
          thisVue.formState = formStates.ready
        } else {
          thisVue.formState = formStates.outsideSubmissionPeriod
        }
      })
      .catch(function () {
        thisVue.loadingError = true
      })
  },
  data: function () {
    return {
      formState: formStates.loading,
      loadingError: false,
      errorMessage: '',
      submissionResult: {},
      // allowBasketball: true,
      // allowFootball: true,
      fullUniversityName: '',
      contact: {
        primary: {
          fullName: '',
          lineId: '',
          phone: '',
          email: '',
          isPresident: false
        },
        secondary: {
          fullName: '',
          lineId: '',
          phone: '',
          email: ''
        }
      },
      rawAttendees: {
        fromSameUniversity: '',
        nonUK: ''
      },
      attendeesFromOtherUniversitiesAddCount: 0,
      rawAttendeesFromOtherUniversities: [],
      athletesFromSameUniversityAddCount: 0,
      athletesFromSameUniversiy: [],
      athletesFromOtherUniversityAddCount: 0,
      athletesFromOtherUniversiy: [],
      rawChairballAthletes: ''
    }
  },
  computed: {
    niceUniversityName: function () { return this.fullUniversityName.trim() ? this.fullUniversityName : 'this university' },
    attendeesFromSameUniversity: function () {
      return this.rawAttendees.fromSameUniversity.split('\n').filter(n => n.trim())
    },
    attendeesNonUK: function () {
      return this.rawAttendees.nonUK.split('\n').filter(n => n.trim())
    },
    attendeesFromOtherUniversities: function () {
      return this.rawAttendeesFromOtherUniversities.map(
        entry => ({
          // key: entry.key,
          universityName: entry.universityName,
          students: entry.list.split('\n').filter(n => n.trim())
        })
      )
    },
    grandTotalAttendees: function () {
      var attendeesFromOtherUniversitiesCount = 0
      this.attendeesFromOtherUniversities.forEach(function (entry) {
        attendeesFromOtherUniversitiesCount += entry.students.length
      })
      return this.attendeesFromSameUniversity.length +
        this.attendeesNonUK.length +
        attendeesFromOtherUniversitiesCount
    },
    athletesChairball: function () {
      return this.rawChairballAthletes.split('\n').filter(n => n.trim())
    },
    grandTotalAthletes: function () {
      return this.athletesFromSameUniversiy.length + this.athletesFromOtherUniversiy.length + this.athletesChairball.length
    },
    eligibleFreeAttendeeTickets: function () {
      return parseInt(this.grandTotalAthletes / 10)
    },
    discountedAttendeeTickets: function () {
      return Math.min(this.eligibleFreeAttendeeTickets, this.grandTotalAttendees)
    },
    athleteAmount: function () {
      return this.grandTotalAthletes * 400
    },
    attendeeAmount: function () {
      return this.grandTotalAttendees * 150
    },
    subTotal: function () {
      return this.athleteAmount + this.attendeeAmount
    },
    discountTotal: function () {
      return this.discountedAttendeeTickets * 150
    },
    grandTotal: function () {
      return this.subTotal - this.discountTotal
    }
  },
  components: {
    // HelloWorld
  },
  methods: {
    addAtttendeeUniversity: function () {
      this.rawAttendeesFromOtherUniversities.push({
        key: this.attendeesFromOtherUniversitiesAddCount++,
        universityName: '',
        list: ''
      })
    },
    removeAttendeeUniversity: function (index) {
      this.rawAttendeesFromOtherUniversities.splice(index, 1)
    },
    validateAttendeesList: function (event) {
      if (event.target.value.split('\n').filter(n => n.trim()).length > 0) {
        event.target.setCustomValidity('')
      } else {
        event.target.setCustomValidity('Need at least one entry')
      }
      // event.target.reportValidity()
    },
    addAthleteFromSameUniversity: function () {
      this.athletesFromSameUniversiy.push({
        key: this.athletesFromSameUniversityAddCount++,
        fullName: '',
        isAlumni: false,
        playBasketball: false,
        playFootball: false
      })
      window.setTimeout(function (that) {
        that.validateSportsFromSameUniversity(
          that.athletesFromSameUniversityAddCount - 1,
          that.athletesFromSameUniversiy.length - 1
        )
      }, 100, this)
    },
    removeAthleteFromSameUniversity: function (index) {
      this.athletesFromSameUniversiy.splice(index, 1)
    },
    validateSportsFromSameUniversity: function (key, index) {
      if (this.athletesFromSameUniversiy[index].playFootball ||
          this.athletesFromSameUniversiy[index].playBasketball) {
        this.$refs['playBasketballSameUniversityCheckbox_' + key].setCustomValidity('')
        this.$refs['playFootballSameUniversityCheckbox_' + key].setCustomValidity('')
      } else {
        this.$refs['playBasketballSameUniversityCheckbox_' + key].setCustomValidity('Need at least one sport')
        this.$refs['playFootballSameUniversityCheckbox_' + key].setCustomValidity('Need at least one sport')
      }
    },
    addAthleteFromOtherUniversity: function () {
      this.athletesFromOtherUniversiy.push({
        key: this.athletesFromOtherUniversityAddCount++,
        fullName: '',
        universityName: '',
        isAlumni: false,
        playBasketball: false,
        playFootball: false
      })
      window.setTimeout(this.validateSportsFromOtherUniversity, 100)
    },
    removeAthleteFromOtherUniversity: function (index) {
      this.athletesFromOtherUniversiy.splice(index, 1)
      window.setTimeout(this.validateSportsFromOtherUniversity, 100)
    },
    validateSportsFromOtherUniversity: function () {
      var footballCount = 0
      var basketballCount = 0
      // Mark that there is at least one athlete who is not playing any sport
      var noSportExist = false
      this.athletesFromOtherUniversiy.forEach(function (athlete, index) {
        if (!athlete.playFootball && !athlete.playBasketball) {
          noSportExist = true
          this.$refs['playBasketballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('Need at least one sport')
          this.$refs['playFootballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('Need at least one sport')
        } else {
          this.$refs['playBasketballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('')
          this.$refs['playFootballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('')
        }
        if (athlete.playFootball) footballCount++
        if (athlete.playBasketball) basketballCount++
      }, this)
      // console.log(noSportExist, footballCount, basketballCount)
      // If every athlete play at least one sport
      if (!noSportExist &&
          // and some of the sport has too many athletes
          (footballCount > 4 || basketballCount > 3)) {
        this.athletesFromOtherUniversiy.forEach(function (athlete, index) {
          if (footballCount > 4) {
            this.$refs['playFootballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('Only four external football players at maximum')
          }
          if (basketballCount > 3) {
            this.$refs['playBasketballOtherUniversityCheckbox_' + athlete.key].setCustomValidity('Only three external basketball players at maximum')
          }
        }, this)
      }
    },
    onSubmit: function (event) {
      var validity = event.target.reportValidity()
      if (validity) {
        if (this.grandTotalAthletes <= 0 && this.grandTotalAttendees <= 0) {
          alert('There should be at least one attendee or one athlete')
        } else {
          // A football team must have at least 7 members
          // and a basketball team must have at least 5 members
          var footballPlayersCount = 0
          var basketballPlayersCount = 0
          var chairballPlayersCount = this.athletesChairball.length
          var athleteCounter = function (athlete) {
            if (athlete.playFootball) footballPlayersCount++
            if (athlete.playBasketball) basketballPlayersCount++
          }
          this.athletesFromSameUniversiy.forEach(athleteCounter)
          this.athletesFromOtherUniversiy.forEach(athleteCounter)

          if (footballPlayersCount > 0 && footballPlayersCount < 7) {
            alert('There should be at least 7 players in a football team')
          } else if (basketballPlayersCount > 0 && basketballPlayersCount < 5) {
            alert('There should be at least 5 players in a basketball team')
          } else if (chairballPlayersCount > 0 && chairballPlayersCount < 7) {
            alert('There should be at least 7 players in a chairball team')
          } else {
            // All validation pass, proceed
            this.sendSubmission()
          }
        }
      }
    },
    serialiseForm: function () {
      return {
        fullUniversityName: this.fullUniversityName,
        contact: {
          primary: Object.assign({}, this.contact.primary),
          secondary: Object.assign({}, this.contact.secondary)
        },
        attendees: {
          fromSameUniversity: this.attendeesFromSameUniversity,
          nonUK: this.attendeesNonUK,
          fromOtherUniversity: this.attendeesFromOtherUniversities
        },
        athletes: {
          fromSameUniversity: this.athletesFromSameUniversiy.map(
            athlete => ({
              fullName: athlete.fullName,
              isAlumni: athlete.isAlumni,
              plays: []
                .concat(athlete.playFootball ? ['football'] : [])
                .concat(athlete.playBasketball ? ['basketball'] : [])
            })
          ),
          fromOtherUniversity: this.athletesFromOtherUniversiy.map(
            athlete => ({
              fullName: athlete.fullName,
              universityName: athlete.universityName,
              isAlumni: athlete.isAlumni,
              plays: []
                .concat(athlete.playFootball ? ['football'] : [])
                .concat(athlete.playBasketball ? ['basketball'] : [])
            })
          ),
          chairball: this.athletesChairball
        }
      }
    },
    sendSubmission: function () {
      var thisVue = this
      this.formState = formStates.loading
      this.loadingError = false
      // console.log(this.serialiseForm())
      this.gamesApi.post('/registrations', this.serialiseForm())
        .then(function (response) {
          // console.log(response.data)
          thisVue.formState = formStates.submittedSuccess
          thisVue.submissionResult = response.data
        })
        .catch(function (error) {
          thisVue.formState = formStates.submittedFailed
          thisVue.errorMessage = error.data.message
        })
    }
  }
}
</script>

<style>
.bigger {
  font-size: 1.15em;
}
.font-bold {
  font-weight: bold;
}
.app-container {
  margin: 1.618em auto 1em;
  max-width: 720px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#app {
  margin: 0 1em;
}
#appForm > section,
#appForm > footer {
  margin: 4.236em 0;
}
#appForm > section > section {
  margin: 2.6179em 0;
}
.games-logo {
  height: 15rem;
  display: block;
  margin: 1.618rem auto;
}
.box{
  background-color: #AAC8D150;
  border-radius: 0.2rem;
  padding: 1rem 0 .5rem .5rem;
  margin-bottom: 1rem;
}
.input-block,
.button-block {
  margin: 1.618em 0;
}
.input-block > div {
  margin: 1em 0;
}
.input-block input {
  margin: 0;
  display: inline;
  vertical-align: middle;
}
.input-block input[type=checkbox] {
  margin-right: .618em;
}
.input-block input[type=text],
.input-block input[type=email],
.input-block input[type=tel],
.input-block textarea,
.input-block label {
  width: 100%;
  box-sizing: border-box;
  display: block;
}
.input-block input[type=text],
.input-block input[type=email],
.input-block input[type=tel],
.input-block textarea {
  padding: .618em;
  border: 1px solid #555555;
  border-radius: 3px;
  font-size: 15px;
}
.input-block input[type=checkbox]:invalid {
  box-shadow: 0 0 3px red;
}
.input-block input[type=text]:invalid,
.input-block input[type=email]:invalid,
.input-block input[type=tel]:invalid,
.input-block textarea:invalid {
  border-color: red;
  box-shadow: none;
}
.input-block textarea {
  resize: vertical;
  height: 7em;
  max-height: 15em;
  min-height: 4em;
}
.input-block label {
  margin: .618em 0;
  font-weight: 500;
  font-size: 1rem;
}
/* Dashed red border */
hr.dashed {
  border-top: 1px dashed #EDEDED;
}
</style>
